<template>
  <div>
    <v-form @submit.prevent="buscarPersona" class="d-flex justify-center align-center">
      <v-text-field class @blur="buscarPersona" :label="label || 'Ingrese un valor '" v-model="filtro"
        :hint="personaDescripcion || error" persistent-hint :error="!!error" :loading="loading"></v-text-field>
    </v-form>
  </div>
</template>

<script>
import PersonaService from '../../services/Persona.service'
export default {
  props: ["value", "label"],

  data() {
    return {
      error: "",
      filtro: "",
      personas: null,
      loading: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        console.log("wvalue", val);
        this.filtro = val;
        this.buscarPersona();
      } else {
        this.filtro = "";
        this.personas = null;
      }
    },
  },
  computed: {
    personaDescripcion: function () {
      if (!this.personas||this.personas.length > 1) return "";
      return (
        this.personas[0].apellido +
        " " +
        (this.personas[0].nombre===undefined ?'':this.personas[0].nombre)
      );
    },
  },
  methods: {
    buscarPersona() {
      if (this.filtro && this.filtro != "") {
        this.error = "";
        this.personas = null;
        this.loading = true;
        PersonaService.ObtenerDocente(this.filtro)
          .then((res) => {
            if(res.data.length>0){
              console.log(res.data);
              this.personas = res.data;
              this.$emit("input", +this.filtro);
              this.$emit('personas:change', this.personas);
            }
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            this.error = "Datos inválidos";
            this.$emit("input", null);
            this.$emit('personas:change', null);
          });
      } else {
        this.filtro = "";
        this.personas = null;
        this.$emit("input", null);
        this.$emit('personas:change', null);
      }
    },
  },
  mounted() {
    this.filtro = this.value;
    this.buscarPersona();
   },
};
</script>

<style lang="scss" scoped>
</style>